import { ActivityIndicator, Text } from '@capsicum/common-web';
import { type NCWMigrationIndicatorProps, useNCWMigrationIndicator } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const NCWMigrationIndicator = ({ variant }: NCWMigrationIndicatorProps) => {
	const { intlText } = useNCWMigrationIndicator({ variant });

	return (
		<S.Wrapper>
			<S.MigrationLoader />
			<Text color="main.enabled" variant="text4">
				{intlText.migratingText}
			</Text>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		padding: ${({ theme }) =>
			`${theme.spacings.large} ${theme.spacings.large} ${theme.spacings.xxxsmall} ${theme.spacings.large}`};
		color: ${({ theme }) => theme.colors.backgrounds.main.container};
		text-align: center;
	`;

	export const MigrationLoader = styled(ActivityIndicator)`
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
